import { lazy } from 'react';

const BeerList = lazy(() => import('../../components/pages/BeerList/BeerList'));
const AddBeer = lazy(() => import('../../components/pages/AddBeer/AddBeer'));
const EditBeer = lazy(() => import('../../components/pages/EditBeer/EditBeer'));
const NonCompliance = lazy(() =>
  import('../../components/pages/NonCompliance/NonCompliance'),
);
const AddSource = lazy(() =>
  import('../../components/pages/AddSource/AddSource'),
);
const EditSource = lazy(() =>
  import('../../components/pages/EditSource/EditSource'),
);
const AddArea = lazy(() => import('../../components/pages/AddArea/AddArea'));
const EditArea = lazy(() => import('../../components/pages/EditArea/EditArea'));
const AddInconformity = lazy(() =>
  import('../../components/pages/AddInconformity/AddInconformity'),
);
const BinList = lazy(() => import('../../components/pages/BinList/BinList'));
const EditBin = lazy(() => import('../../components/pages/EditBin/EditBin'));
const EditInconformity = lazy(() =>
  import('../../components/pages/EditInconformity/EditInconformity'),
);
const AddDesNon = lazy(() =>
  import('../../components/pages/AddDesNon/AddDesNon'),
);
const EditDesNon = lazy(() =>
  import('../../components/pages/EditDesNon/EditDesNon'),
);
const AddAdditionalDes = lazy(() =>
  import('../../components/pages/AddAdditionalDes/AddAdditionalDes'),
);
const EditAdditionalDes = lazy(() =>
  import('../../components/pages/EditAdditionalDes/EditAdditionalDes'),
);
const ReasonList = lazy(() =>
  import('../../components/pages/ReasonList/ReasonList'),
);
const AddReason = lazy(() =>
  import('../../components/pages/AddReason/AddReason'),
);
const EditReason = lazy(() =>
  import('../../components/pages/EditReason/EditReason'),
);
const SpecificationList = lazy(() =>
  import('../../components/pages/SpecificationList/SpecificationList'),
);
const AddSpecification = lazy(() =>
  import('../../components/features/AddSpecification/AddSpecification'),
);
const EditSpecification = lazy(() =>
  import('../../components/pages/EditSoecification/EditSpecification'),
);
const AddBrand = lazy(() => import('../../components/pages/AddBrand/AddBrand'));
const EditBrand = lazy(() =>
  import('../../components/pages/EditBrand/EditBrand'),
);
const AddPackage = lazy(() =>
  import('../../components/pages/AddPackage/AddPackage'),
);
const EditPackage = lazy(() =>
  import('../../components/pages/EditPackage/EditPackage'),
);

const CustomersPage = lazy(() =>
  import('../../components/pages/Customers/CustomersPage'),
);

export const masterDataRoutes = [
  {
    path: '/customers',
    permission: 'mix.settings',
    access: 'authenticated',
    Component: CustomersPage,
  },
  {
    path: '/beer',
    permission: 'master.products.view',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: BeerList,
  },
  {
    path: '/add-beer',
    permission: 'master.products.manage',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: AddBeer,
  },
  {
    path: '/edit-beer/:id',
    permission: 'master.products.manage',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: EditBeer,
  },
  {
    path: '/noncompliant',
    permission: 'master.dictionaries.manage',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: NonCompliance,
  },
  {
    path: '/pochodzenie',
    permission: 'master.dictionaries.view',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: AddSource,
  },
  {
    path: '/edit-source/:id',
    permission: 'master.dictionaries.manage',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: EditSource,
  },
  {
    path: '/obszar',
    permission: 'master.dictionaries.view',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: AddArea,
  },
  {
    path: '/edit-area/:id',
    permission: 'master.dictionaries.manage',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: EditArea,
  },
  {
    path: '/rodzaj',
    permission: 'master.dictionaries.view',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: AddInconformity,
  },
  {
    path: '/bins',
    permission: 'master.bins.view',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: BinList,
  },
  {
    path: '/edit-bin/:id',
    permission: 'master.bins.manage',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: EditBin,
  },
  {
    path: '/edit-inconformity/:id',
    permission: 'master.dictionaries.manage',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: EditInconformity,
  },
  {
    path: '/opis',
    permission: 'master.dictionaries.view',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: AddDesNon,
  },
  {
    path: '/edit-desNon/:id',
    permission: 'master.dictionaries.manage',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: EditDesNon,
  },
  {
    path: '/dodatkowy-opis',
    permission: 'master.dictionaries.view',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: AddAdditionalDes,
  },
  {
    path: '/edit-description/:id',
    permission: 'master.dictionaries.manage',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: EditAdditionalDes,
  },
  {
    path: '/przyczyny',
    permission: 'master.reasons.view',
    access: 'authenticated',
    roles: ['ADMIN', 'KIER_DS_REKLAMACJI', 'KONTROLER'],
    Component: ReasonList,
  },
  {
    path: '/add-reason',
    permission: 'master.reasons.manage',
    access: 'authenticated',
    roles: ['ADMIN', 'KIER_DS_REKLAMACJI'],
    Component: AddReason,
  },
  {
    path: '/edit-reason/:id',
    permission: 'master.reasons.manage',
    access: 'authenticated',
    roles: ['ADMIN', 'KIER_DS_REKLAMACJI'],
    Component: EditReason,
  },
  {
    path: '/specifications',
    permission: 'master.specifications.view',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: SpecificationList,
  },
  {
    path: '/add-specification',
    permission: 'master.specifications.manage',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: AddSpecification,
  },
  {
    path: '/edit-specification/:id',
    permission: 'master.specifications.manage',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: EditSpecification,
  },
  {
    path: '/marka',
    permission: 'master.dictionaries.view',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: AddBrand,
  },
  {
    path: '/edit-brand/:id',
    permission: 'master.dictionaries.manage',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: EditBrand,
  },
  {
    path: '/opakowanie',
    permission: 'master.dictionaries.view',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: AddPackage,
  },
  {
    path: '/edit-package/:id',
    permission: 'master.dictionaries.manage',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: EditPackage,
  },
];
